<div class="container">
    <div class="row mb-1">
        <div class="col-md-12 text-end">
            <button (click)="back()" class="btn-shadow  d-inline-flex align-items-center btn btn-success">
                <i class="fa fa-arrow-circle-left mr-5"></i>   Back  </button>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12">
            <div class="main-card mb-3 card">
                <div class="card-header font-weight-B fs-1r">User Details</div>
                <div class="card-body">

                    <div class="row">
                        <div class="col-md-1">    </div>
                        <div class="col-md-3">
                            <label for="">
                                 User Name 
                            </label> 
                            <input type="text" [ngModel]="userDetail?.firstName+' '+userDetail?.lastName"  class="form-control " readonly>
                        </div>

                        <div class="col-md-3">  
                            <label for="">
                                  ID 
                            </label>
                            <input type="text" [ngModel]="userDetail?._id"  class="form-control " readonly>
                        </div>
                        <div class="col-md-1">  
                            <label for="">
                                 User ID 
                            </label>
                            <input type="text" [ngModel]="userDetail?.userID"  class="form-control " readonly>
                        </div>
                     
                    
                        <div class="col-md-3">
                            <label for="">
                                 User Type 
                            </label> 
                            <input type="text" [ngModel]="userDetail?.userType"  class="form-control " readonly>
                        </div>
                        <div class="col-md-1">    </div>
                    </div>


                    <div class="row mt-2">
                        <div class="col-md-1">    </div>
                     
                      
                        
                        <div class="col-md-3">  
                            <label for="">
                                 Mobile Number 
                            </label>
                            <input type="text" [ngModel]="userDetail?.phoneNumber"  class="form-control" readonly>
                        </div>
                        <div class="col-md-4">
                            <label for="">
                                 Email ID 
                            </label> 
                            <input type="text" [ngModel]="userDetail?.emailId"  class="form-control" readonly>
                        </div>
                        <div class="col-md-3">  
                            <label for="">
                                 Created On 
                            </label>
                            <input type="text" [ngModel]="userDetail?.createdOn | date:'dd MMM yyyy'"  class="form-control" readonly>
                        </div>
                        <div class="col-md-1">    </div>
                    </div>

                    <div class="row mt-2">
                        <div class="col-md-1">    </div>
                        <div class="col-md-3">
                            <label for="">
                                 City 
                            </label> 
                            <input type="text" [ngModel]="userDetail?.city"  class="form-control" readonly>
                        </div>
                        <div class="col-md-4">  
                            <label for="">
                                 State
                            </label>
                            <input type="text" [ngModel]="userDetail?.state"  class="form-control" readonly>
                        </div>
                        <div class="col-md-3">
                            <label for="">
                                 Pincode 
                            </label> 
                            <input type="text" [ngModel]="userDetail?.pincode"  class="form-control" readonly>
                        </div>
                        <div class="col-md-1">    </div>
                    </div>

                    <div class="row mt-2">
                        <div class="col-md-1">    </div>
                        <div class="col-md-3">
                            <label for="">
                                 Ref. By 
                            </label> 
                            <input type="text" [ngModel]="userDetail?.refBy == null ? 'Nill' : userDetail.refBy"  class="form-control" readonly>
                        </div>
                        <div class="col-md-4">  
                            <label for="">
                                 Verid
                            </label>
                           <span> <input type="text" [ngModel]="userDetail?.verid"  class="form-control" readonly> </span>
                        </div>
                        <div class="col-md-3">  
                            <label for="">
                                 Activation Status
                            </label>
                           <span> <input type="text" [ngModel]="userDetail?.activationStatus == 1? 'Enabled' : 'Disabled' "  class="form-control" readonly> </span>
                        </div>
                        <div class="col-md-1">    </div>
                    </div>

                    <div class="row mt-2"  >
                        <div class="col-md-1">    </div>
                        <div class="col-md-3">
                            <label for="">
                                 KYC 
                            </label> 
                            <input type="text" [ngModel]="userDetail?.kyc == 1 ? 'YES' : 'NO'"  class="form-control" readonly>
                        </div>
                        <div class="col-md-4">
                            <label for="">
                                 Source 
                            </label> 
                            <input type="text" [ngModel]="userDetail?.source"  class="form-control" readonly>
                        </div>
                        <div class="col-md-3">  
                            <label for="">
                                 Ref. Code
                            </label>
                           <span> <input type="text" [ngModel]="userDetail?.refCode"  class="form-control" readonly> </span>
                        </div>
                        <div class="col-md-1">    </div>
                    </div>

                    <div class="row mt-2">
                        <div class="col-md-1">    </div>
                       
                        <div class="col-md-3">  
                            <label for="">
                                 Phone Verified
                            </label>
                           <span> <input type="text" [ngModel]="userDetail?.isPhoneVerified == 1 ? 'YES' : 'NO'"  class="form-control" readonly> </span>
                        </div>
                        <div class="col-md-4">  
                            <label for="">
                                 IP Address
                            </label>
                           <span> <input type="text" [ngModel]="userDetail?.ipAddress"  class="form-control" readonly> </span>
                        </div>
                        <div class="col-md-3">
                            <label for="">
                                 Two Factor 
                            </label> 
                            <input type="text" [ngModel]="userDetail?.two_factor == 1 ? 'YES' : 'NO'"  class="form-control" readonly>
                        </div>
                        <div class="col-md-1">    </div>
                    </div>

                    </div>
            </div>

    </div>
    </div>

</div>